/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Helper serializer that validates that every element of a FeedbackForm or
 * FeedbackFormSubmission consists of the required properties.
 * @export
 * @interface APIFeedbackFormFieldRequest
 */
export interface APIFeedbackFormFieldRequest {
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackFormFieldRequest
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackFormFieldRequest
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof APIFeedbackFormFieldRequest
     */
    formFieldType: string;
    /**
     * 
     * @type {boolean}
     * @memberof APIFeedbackFormFieldRequest
     */
    required?: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof APIFeedbackFormFieldRequest
     */
    xl?: number | null;
}

/**
 * Check if a given object implements the APIFeedbackFormFieldRequest interface.
 */
export function instanceOfAPIFeedbackFormFieldRequest(value: object): value is APIFeedbackFormFieldRequest {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('formFieldType' in value) || value['formFieldType'] === undefined) return false;
    return true;
}

export function APIFeedbackFormFieldRequestFromJSON(json: any): APIFeedbackFormFieldRequest {
    return APIFeedbackFormFieldRequestFromJSONTyped(json, false);
}

export function APIFeedbackFormFieldRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIFeedbackFormFieldRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'formFieldType': json['form_field_type'],
        'required': json['required'] == null ? undefined : json['required'],
        'xl': json['xl'] == null ? undefined : json['xl'],
    };
}

export function APIFeedbackFormFieldRequestToJSON(value?: APIFeedbackFormFieldRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'key': value['key'],
        'label': value['label'],
        'form_field_type': value['formFieldType'],
        'required': value['required'],
        'xl': value['xl'],
    };
}

